<template>
  <div class="popup-main">
    <el-dialog
      width="420px"
      title="与客户同步关联"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
    >
      <el-form ref="refForm" :rules="rules" :model="selfData" label-width="120px">
        <el-form-item label="供应商名称" prop="supplier_name">
          <el-input v-model="selfData.supplier_name" readonly size="mini" />
        </el-form-item>
        <el-form-item label="关联客户:" prop="customer_name">
          <el-select
            size="mini"
            placeholder="可搜索查询"
            default-first-option
            remote
            filterable
            clearable
            :remote-method="getCustomerList"
            :style="{ width: '100%' }"
            v-model="selfData.customer_name"
            @change="
              (selfData.customer_name = $event.customer_name),
                (selfData.customer_uuid = $event.company_uuid)
            "
          >
            <el-option
              v-for="(item, index) in customerListData"
              :key="index"
              :label="item.customer_name"
              :value="item"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selfShow: false,
      selfData: {},
      rules: {
        supplier_name: [{ required: true, message: '请输入供应商名称' }],
        customer_name: [{ required: true, message: '请输入关联客户' }]
      },
      customerListData: []
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    },
    data: {
      handler(val) {
        if (JSON.stringify(this.selfData) !== JSON.stringify(val)) {
          this.selfData = this.$util.deepCopy(val)
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.selfShow = this.show
    this.getCustomerList()
  },
  methods: {
    // 获取客户列表
    getCustomerList(query = '') {
      this.$api({
        method: 'post',
        url: '/admin/customers/search',
        data: {
          filterData: {
            customer_name: query
          },
          pageSize: 200
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.customerListData = res.data.page.list
        }
      })
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      this.$refs.refForm.validate((valid) => {
        if (valid) {
          this.popupCancel()
          // 编辑供应商uuid，与客户进行关联
          this.$confirm(`'将会同步客户UUID为供应商UUID，不可恢复！'`, '提示')
            .then(() => {
              this.$api({
                method: 'post',
                url: '/admin/supplier/changeUuid',
                data: {
                  changeUuidForm: this.selfData
                }
              }).then((res) => {
                if (res.data.state === 'ok') {
                  this.$parent.getListData()
                  this.$message.success('同步成功')
                }
              })
            })
            .catch(() => {})
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
